import { FC, useState } from 'react';
import { ConfirmationDialog, TextField } from '../../../../lib/components';
import { useTranslation } from 'react-i18next';
import { ViewModelProps } from '../../../../lib/base/viewModels';
import { observer } from 'mobx-react-lite';
import { ReceiptAction, ReceiptActionDialogViewModel } from './viewModel';

interface Props {
  action: ReceiptAction;
  count: number;
  onConfirm: (note?: string) => void;
  onClose: () => void;
  onCancel?: () => void;
  totalCount?: number;
  open?: boolean;
}

export const ReceiptActionDialogNew: FC<ViewModelProps<ReceiptActionDialogViewModel>> = observer(
  ({ viewModel }) => {
    return (
      <ConfirmationDialog
        open={viewModel.isOpen}
        title={viewModel.title}
        contentText={viewModel.text}
        onConfirm={() => viewModel.confirm()}
        onCancel={() => viewModel.cancel()}
        onClose={() => viewModel.close()}
        confirmButtonText={viewModel.confirmButtonText}
        contentComponent={viewModel.contentComponent}
        cancelButtonText={viewModel.cancelButtonText}
        hideCancelButton={viewModel.applicableCount == 0}
        variant={viewModel.variant}
      />
    );
  }
);

export const ReceiptActionDialog: FC<Props> = ({
  action,
  count,
  onConfirm,
  onClose,
  onCancel,
  totalCount,
  open = false
}) => {
  const { t } = useTranslation();
  const type = (totalCount ?? count) <= count ? 'TOTAL' : 'PARTIAL';
  const contentText =
    action === 'delete' || action === 'settle'
      ? type === 'TOTAL'
        ? t('receipts:DELETE_DIALOG_TEXT')
        : t('receipts:DELETE_DIALOG_INFO')
      : '';
  const [note, setNote] = useState<string>();

  return (
    <ConfirmationDialog
      open={open}
      title={t(`receipts:ACTION_DIALOG_TITLE_${type}`, {
        context: action,
        count: count,
        totalCount: totalCount
      })}
      contentText={contentText}
      onConfirm={() => onConfirm(note)}
      onCancel={onCancel}
      onClose={onClose}
      confirmButtonText={
        count > 0
          ? t('receipts:CONFIRM_ACTION', { context: action, count: count })
          : t('common:BACK')
      }
      contentComponent={
        action === 'reject' ? (
          <TextField label={t('common:NOTE')} onChange={(e) => setNote(e.target.value)} />
        ) : undefined
      }
      cancelButtonText={t('common:CANCEL')}
      hideCancelButton={count == 0}
      variant={action === 'delete' ? 'delete' : 'warning'}
    />
  );
};
